import React, { useState } from "react";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import IconShow from "canvas-core-react/lib/IconShow";
import StatusBadge from "canvas-core-react/lib/StatusBadge";
import { useTranslation } from "react-i18next";

import DinamicTable from "../../shared/table";
import Modal from "../../utils/customModal";

const STATES_VARIANTS = {
  TRANSITORY: {
    type: "default",
    class: "pending provider-table-attribute",
  },
  ACTIVE: {
    type: "success",
    class: "success provider-table-attribute",
  },
  INACTIVE: {
    type: "error",
    class: "error1 provider-table-attribute",
  },
  REJECTED: {
    type: "error",
    class: "rejected-payment provider-table-attribute",
  },
  DELETED: {
    type: "error",
    class: "rejected-payment provider-table-attribute",
  },
};

const defOption = { returnObjects: true };

const TableManagementProvider = ({ data = [], ...props }) => {
  const [{ page, sizePerPage, modal, menus }, setState] = useState({
    page: 0,
    sizePerPage: props.sizePerPage,
    filters: props.filters,
    modal: { show: false, content: null, onclose: undefined },
    menus: [],
  });

  const { t } = useTranslation();
  const { headers, states } = {
    headers: t("providers.table.headers", defOption),
    states: t("general.states", defOption),
  };

  const handleTableChange = async ({
    page,
    sizePerPage,
    sort = "",
    property = "",
  }) => {
    const { getAllProviders, filters } = props;
    let currentFilters = filters;
    currentFilters =
      property !== "" && property !== null
        ? currentFilters.push({
            property: "sort",
            value: `${property},${sort}`,
          })
        : [];
    try {
      await getAllProviders(page, sizePerPage, currentFilters);
      setState((prev) => ({
        ...prev,
        page,
        sizePerPage,
        order: sort,
        sortBy: property,
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const handleMenu = (id, open) => {
    menus[`menu-${id}`] = open;
    setState((prev) => ({ ...prev, menus }));
  };

  const getTableColumns = () => {
    return [
      {
        selector: "institutionName",
        name: headers.company_provider,
        grow: 2,
      },
      {
        selector: "identification",
        name: headers.idProvider,
        cellFormatter: (row) => (
          <p
            className="TextCaption__text TableBody__cellItem"
            title={row.identification}
          >
            {row.identification}
          </p>
        ),
      },
      { selector: "country", name: headers.country },
      // { selector: "type", name: headers.typeProvider },
      { selector: "status", name: headers.state, center: true },
      {
        selector: "action",
        center: true,
        name: headers.actions,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            iconType="horizontal-small"
            isMenuOpen={menus[`menu-${row.id}`] || false}
            setIsMenuOpen={(open) => handleMenu(row.id, open)}
          >
            {setMenuItems(row).map((item) => item)}
          </ActionMenuList>
        ),
      },
    ];
  };

  const setMenuItems = ({ providerId, id, clientId }) => {
    return [
      <ActionMenuListItem
        key={`profile-${providerId}`}
        icon={() => <IconShow className="TextButton__icon--left" />}
        onClick={() =>
          showProfile(
            id,
            `/bscadministrator/providers/${providerId}/${clientId}/profile`
          )
        }
      >
        {t("detail")}
      </ActionMenuListItem>,
    ];
  };

  const showProfile = (id, url) => {
    menus[`menu-${id}`] = false;
    setState((prev) => ({ ...prev, menus }));
    props?.history?.push(url);
  };

  const setTableData = () => {
    return data?.map((item) => {
      const stateComponent = STATES_VARIANTS[item.provider.status];
      const type = item.provider.toBillDiscount ? "discount" : "directPayment";
      return {
        id: `${item.provider.relation.id}-${item.provider.id}`,
        institutionName: item.name,
        identification: item.businessId,
        toBillDiscount: item.provider.toBillDiscount,
        type: t(`providerType.${type}`),
        institutionBelong: item.provider.relation.name,
        country: item.provider.country.name,
        status: (
          <StatusBadge
            type={stateComponent?.type || "default"}
            className={`${
              stateComponent?.class || "pending provider-table-attribute"
            }`}
          >
            {states[item.provider?.status] || item.provider.status}
          </StatusBadge>
        ),
        providerId: item.provider.id,
        globalApproval: item.provider.globalApproval ? "Sí" : "No",
        globApproval: item.provider.globalApproval,
        clientId: item.provider.relation.company.id,
        invitationStatus:
          item.provider.toBillDiscount === true
            ? "-"
            : t(`general.inviteStates.${item.provider.invitationStatus}`),
      };
    });
  };

  /*   const getAction = (item) => {
    const { action, actionlbl } = props;
    if (null === action) {
      return (
        <Link
          to={`/bscadministrator/providers/${item.provider.id}/${item.provider.relation.company.id}/profile`}
        >
          <button id="detail" className="button-table button--pill-table">
            Ver Perfil
          </button>
        </Link>
      );
    } else {
      return (
        <button
          className="button-table button--pill-table"
          onClick={() => action(item)}
        >
          {actionlbl}
        </button>
      );
    }
  };
 */
  const { totalSize } = props;

  return (
    <>
      <DinamicTable
        headers={getTableColumns()}
        data={setTableData()}
        page={page}
        totalSize={totalSize}
        sizePerPage={sizePerPage}
        onTableChange={handleTableChange}
      />
      <Modal show={modal.show} handleClose={modal.onclose}>
        {modal.content}
      </Modal>
    </>
  );
};

export default TableManagementProvider;

/* export class TableManagementProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: props.sizePerPage,
      filters: props.filters,
      modal: { show: false, content: null, onclose: undefined },
      menus: [],
    };
  }

      componentDidUpdate() {
    if (this.state.filters !== this.props.filters) {
      this.setState({ page: 0, filters: this.props.filters });
    }
  } 

  handleTableChange = ({ page, sizePerPage, sort = "", property = "" }) => {
    const { getAllProviders, filters } = this.props;
    var currentFilters = filters;
    currentFilters =
      property !== "" && property !== null
        ? currentFilters.push({
            property: "sort",
            value: `${property},${sort}`,
          })
        : [];

    return getAllProviders(page, sizePerPage, currentFilters).then(() => {
      this.setState({ page: page, sizePerPage, order: sort, sortBy: property });
    });
  };

  handleMenu = (id, open) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = open;
    this.setState({ menus });
  };

  getTableColumns = () => {
    const { menus } = this.state;
    // /bscadministrator/providers/${item.provider.id}/${item.provider.relation.company.id}/profile`
    return [
      { selector: "institutionName", name: "Nombre de la empresa", grow: 2 },
      {
        selector: "identification",
        name: "ID Proveedor",
        cellFormatter: (row) => (
          <p
            className="TextCaption__text TableBody__cellItem"
            title={row.identification}
          >
            {row.identification}
          </p>
        ),
      },
      { selector: "country", name: "País" },
      { selector: "type", name: "Tipo de Proveedor" },
      { selector: "status", name: "Estado", center: true },
      {
        selector: "action",
        center: true,
        name: "Acciones",
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            iconType="horizontal-small"
            isMenuOpen={menus[`menu-${row.id}`] || false}
            setIsMenuOpen={(open) => this.handleMenu(row.id, open)}
          >
            {this.setMenuItems(row).map((item) => item)}
          </ActionMenuList>
        ),
      },
    ];
  };

  setMenuItems = (row) => {
    let items = [];

    items.push(
      <ActionMenuListItem
        key={`profile-${row.providerId}`}
        icon={() => <IconShow className="TextButton__icon--left" />}
        onClick={() =>
          this.showProfile(
            row.id,
            `/bscadministrator/providers/${row.providerId}/${row.clientId}/profile`
          )
        }
      >
        Ver Perfil
      </ActionMenuListItem>
    );

    return items;
  };

  showProfile = (id, url) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = false;
    this.setState({ menus }, () => this.props?.history?.push(url));
  };

  setTableData() {
    var { data, t } = this.props;
    var estado = null;
    var dataResult = [];

    if (data.length > 0) {
      data.map((item) => {
        const stateComponent = STATES_VARIANTS[item.provider.status];

        estado = (
          <StatusBadge
            type={stateComponent?.type || "default"}
            className={`${
              stateComponent?.class || "pending provider-table-attribute"
            }`}
          >
            {stateComponent?.label || item.provider.status}
          </StatusBadge>
        );

        dataResult.push({
          id: `${item.provider.relation.id}-${item.provider.id}`,
          institutionName: item.name,
          identification: item.businessId,
          toBillDiscount: item.provider.toBillDiscount,
          type:
            item.provider.toBillDiscount === true
              ? "Descuento"
              : "Pago Directo",
          institutionBelong: item.provider.relation.name,
          country: item.provider.country.name,
          status: estado,
          providerId: item.provider.id,
          globalApproval: item.provider.globalApproval === true ? "Sí" : "No",
          globApproval: item.provider.globalApproval,
          clientId: item.provider.relation.company.id,
          invitationStatus:
            item.provider.toBillDiscount === true
              ? "-"
              : t(`general.inviteStates.${item.provider.invitationStatus}`),
        });
      });
    }

    return dataResult;
  }

  getAction = (item) => {
    const { action, actionlbl } = this.props;
    if (null === action) {
      return (
        <Link
          to={`/bscadministrator/providers/${item.provider.id}/${item.provider.relation.company.id}/profile`}
        >
          <button id="detail" className="button-table button--pill-table">
            Ver Perfil
          </button>
        </Link>
      );
    } else {
      return (
        <button
          className="button-table button--pill-table"
          onClick={() => action(item)}
        >
          {actionlbl}
        </button>
      );
    }
  };

  render() {
    const { page, sizePerPage, modal } = this.state;
    const { totalSize } = this.props;

    return (
      <>
        <DinamicTable
          headers={this.getTableColumns()}
          data={this.setTableData()}
          page={page}
          totalSize={totalSize}
          sizePerPage={sizePerPage}
          onTableChange={this.handleTableChange}
        />
        <Modal show={modal.show} handleClose={modal.onclose}>
          {modal.content}
        </Modal>
      </>
    );
  }
}

TableManagementProvider.defaultProps = {
  action: null,
  actionlbl: "",
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default connect(
  null,
  mapDispatch
)(withTranslation()(TableManagementProvider));
 */
